import { BDSMForm } from '../../../../../components/form/BDSMForm';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';
import { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { getProductsReceivers, saveProductsReceiver } from '../UserSettingsService';

export const ClientConfigsBlock = () => {

    const { t } = useTranslation('settings');
    const alert = useAlert();
    const [possibleReceivers, setPossibleReceivers] = useState([{ name: t('common:SELECT'), value: -1 }]);
    const [selectedEmployee, setSelectedEmployee] = useState({ productsReceiverId: -1 });


    const validation = Yup.object().shape({
        productsReceiverId: Yup.string().test('test', t('validations:pleaseSelect'), (value) => value !== '-1'),
    });

    useEffect(() => {
        getProductsReceivers()
            .then((response) => setReceivers(response.data))
            .catch(() => alert.error(t('alert:loadingError')));
    }, []);

    const setReceivers = (data) => {
        let temp = [{ name: t('common:SELECT'), value: -1 }];
        temp = temp.concat(data.employees.map(it => ({ name: it.name, value: it.id })));
        setPossibleReceivers(temp);
        if (data.selectedEmployeeId) {
            setSelectedEmployee({ productsReceiverId: data.selectedEmployeeId });
        }
    };

    const handleSubmit = (form) => {
        saveProductsReceiver(form.productsReceiverId)
            .then(() => alert.success(t('alert:saveSuccess')))
            .catch(() => alert.error(t('alert:loadingError')));
    };

    const cancel = () => {
        //  ignore
    };

    const getFormModel = () => {
        return {
            initValues: selectedEmployee,
            onSubmit: (form) => handleSubmit(form),
            onCancel: (c) => cancel(c),
            validationSchema: validation,
            fieldNames: ['productsReceiverId'],
            className: 'mb-3',
            label: [t('productsReceiver.productsReceiver')],
            types: ['select'],
            selectData: [possibleReceivers],
            inputFieldsClass: '',
            hideCancel: true
        };
    };

    return <BDSMForm form={getFormModel()} />;
};